


























































































import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import { FormFieldValidation, ModalHelpers } from '@/mixins';
import { BaseResultModel, DocuSignConstants } from '@/types';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';

export default Vue.extend({
  name: 'DocuSignAccountConfiguration',
  mixins: [FormFieldValidation, ModalHelpers],
  data() {
    return {
      isLoading: true,
      privateKey: '',
      hasError: false,
      docuSignResponse: null,
      submitIsLoading: false
    };
  },
  methods: {
    async getData() {
      this.privateKey = await DocuSignConfigurationService.getPrivateKeyAsync();
    },
    async onSubmit(this: any) {
      this.$validator.errors.remove('validationErrors');
      if (!this.isFormValid()) {
        this.$validator.errors.add({
          field: 'validationErrors',
          msg: 'The private key must have a value'
        });
        return;
      }

      if (!(this.privateKey as string).match(DocuSignConstants.IntegrationPrivateKeyFormatRegex)?.length) {
        const confirmed = await this.showConfirmationModalAsync(
          this.$bvModal,
          `the private key is missing the -----BEGIN RSA PRIVATE KEY----- and -----END RSA PRIVATE KEY----- markers`
        );

        if (!confirmed) {
          return;
        }
      }
      try {
        this.submitIsLoading = true;
        const result: BaseResultModel = await DocuSignConfigurationService.updatePrivateKeyAsync(this.privateKey);

        if (result.hasNotification && !result.showToast) {
          this.addFormValidationError(result.notification);
          return;
        }

        SnotifyConfiguration.showSuccess('DocuSign private key updated successfully.');
        this.setApplicationDirty(false);
        this.resetField('privateKey');
      } catch (error) {
        this.$log('Error updating DocuSign private key.', error);
      } finally {
        this.submitIsLoading = false;
      }
    },
    async sendTest(this: any, dirty: boolean) {
      if (this.isFormDirty() || dirty) {
        const confirmed = await this.showConfirmationModalAsync(
          this.$bvModal,
          'you have not saved the private key,' +
            ' sending a test request will use the old private key until you have saved it'
        );

        if (!confirmed) {
          return;
        }
      }
      try {
        this.submitIsLoading = true;
        this.docuSignResponse = await DocuSignConfigurationService.sendTestDocuSignRequestAsync();
      } catch (error) {
        this.$log('Error updating DocuSign private key.', error);
      } finally {
        this.submitIsLoading = false;
      }
    }
  },
  async mounted() {
    await this.getData();
    this.isLoading = false;
  },
  components: {
    LoadingSpinner,
    MStoreSpinnerButton
  }
});
